import { useAuthStore } from '@/stores/auth.store';
import { AnimatedCard } from '@/components/ui/animated-card';
import { ActivityFeed } from './activity-feed';
import { QuickActions } from './quick-actions';
import { MerchantDashboardPage } from './merchant-dashboard-page';
import { useRecentActivity, useQuickActions } from '../hooks/use-dashboard';

export function DashboardPage() {
  const { user, isGlobalView, currentMerchant } = useAuthStore(state => ({
    user: state.user,
    isGlobalView: state.isGlobalView,
    currentMerchant: state.currentMerchant
  }));
  
  const { data: activities = [], isLoading: activityLoading } = useRecentActivity();
  const { data: actions = [], isLoading: actionsLoading } = useQuickActions();
  
  // Show merchant dashboard for merchant users or when a specific merchant is selected
  const isMerchantUser = user?.role === 'merchant_owner' || user?.role === 'merchant_viewer';
  if (isMerchantUser || (!isGlobalView && currentMerchant)) {
    return <MerchantDashboardPage />;
  }

  return (
    <div className="space-y-6 relative">
      {/* Enhanced Header */}
      <AnimatedCard 
        gradient={true} 
        glow={true} 
        className="p-6 shadow-brand-md hover:shadow-brand-lg transition-all duration-500"
      >
        <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
          <div>
            <h1 className="text-3xl font-bold gradient-text-sunrise mb-2">Dashboard</h1>
            <p className="text-slate-600 font-medium">
              Welcome back, <span className="gradient-text-primary">{user?.displayName || user?.email}</span>
            </p>
          </div>
          <div className="flex items-center gap-3 px-4 py-2 bg-gradient-to-r from-green-500/10 to-emerald-500/10 rounded-full border border-green-200/50 shadow-brand-sm">
            <div className="w-3 h-3 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full animate-pulse shadow-glow-sm" />
            <span className="text-sm font-medium gradient-text-primary">Live Data</span>
          </div>
        </div>
      </AnimatedCard>

      {/* Metrics cards removed per request */}

      {/* Enhanced Activity Feed and Quick Actions */}
      <div className="grid gap-6 lg:grid-cols-7">
        <div className="lg:col-span-4">
          <ActivityFeed 
            activities={activities}
            isLoading={activityLoading}
            className=""
          />
        </div>
        
        <div className="lg:col-span-3">
          <QuickActions
            actions={actions}
            isLoading={actionsLoading}
            className=""
          />
        </div>
      </div>
    </div>
  );
}
